import { Link } from 'react-router-dom';
import { PanelCard } from '../../../components/ui';
import type { AcademicDashboardResponse, DashboardMover } from '../../../api/types';
import { pct, signed } from './format';

function Movers({ title, rows, empty, tone }: { title: string; rows: DashboardMover[]; empty: string; tone: 'up' | 'down' }) {
  return (
    <div>
      <div className="mb-2 font-mono text-[11px] font-semibold uppercase tracking-[0.08em] text-muted">{title}</div>
      {rows.length === 0 ? <p className="text-sm text-muted">{empty}</p> : rows.map((m) => (
        <div key={m.student_id} className="flex min-w-0 justify-between gap-2 py-[5px]">
          <Link to={`/students/profile/${m.student_id}`} className="min-w-0 truncate text-ink no-underline hover:underline">{m.name}</Link>
          <span className={`font-mono font-semibold ${tone === 'up' ? 'text-success' : 'text-danger'}`}>{signed(m.delta)}</span>
        </div>
      ))}
    </div>
  );
}

export default function RemediationCard({ d, className = '' }: { d: AcademicDashboardResponse; className?: string }) {
  return (
    <PanelCard className={className} title="Remediation" actions={<Link to="/class-performance#cycles" className="text-[13px] font-semibold text-muted-2 no-underline hover:text-ink hover:underline">Cycles →</Link>}>
      <div className="grid gap-[18px] min-[820px]:grid-cols-[minmax(0,1fr)_minmax(0,2fr)]">
        <div className="grid grid-cols-3 gap-2">
          <div className="min-w-0 rounded-[12px] bg-surface-2 p-3"><div className="truncate font-mono text-[11px] font-semibold uppercase tracking-[0.08em] text-muted">Active</div><div className="mt-1.5 font-mono text-2xl font-semibold">{d.cycles.active}</div></div>
          <div className="min-w-0 rounded-[12px] bg-surface-2 p-3"><div className="truncate font-mono text-[11px] font-semibold uppercase tracking-[0.08em] text-muted">Crossed pass</div><div className="mt-1.5 font-mono text-2xl font-semibold">{pct(d.cycles.crossed_pass_share, 0)}</div></div>
          <div className="min-w-0 rounded-[12px] bg-navy p-3 text-white"><div className="truncate font-mono text-[11px] font-semibold uppercase tracking-[0.08em] text-on-navy-muted">Avg gain</div><div className="mt-1.5 font-mono text-2xl font-semibold text-accent">{signed(d.cycles.mean_gain)}</div></div>
        </div>
        <div className="grid grid-cols-2 gap-[18px]">
          <Movers title="Most improved" rows={d.movers.improving} tone="up" empty="No student has enough exams in both periods yet." />
          <Movers title="Slipping" rows={d.movers.declining} tone="down" empty="Nobody is slipping by that measure." />
        </div>
      </div>
    </PanelCard>
  );
}
